import { NgTemplateOutlet } from '@angular/common'
import { Component, OnInit, ViewChild, inject } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { RecordActionPanelService } from '@app/feature/record-actions-panel/record-action-panel.service'
import { BreakpointService, DisplaySize } from '@components-library/services/breakpoint.service'
import { TbButtonComponent } from '@components-library/tb-button/tb-button.component'
import { TbCheckboxComponent } from '@components-library/tb-checkbox'
import { TbMenuComponent } from '@components-library/tb-menu'
import { BaseMainBusinessRecord } from '@core/models'
import { TranslocoModule } from '@jsverse/transloco'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { RecordActionButtonsComponent } from '@app/feature/record-actions-panel/record-action-buttons/record-action-buttons.component'
import { ModalLayoutComponent } from '@components-library/tb-modal-manager/modal-layout/modal-layout.component'

@UntilDestroy()
@Component({
    selector: 'app-record-actions-panel',
    templateUrl: './record-actions-panel.component.html',
    styleUrls: ['./record-actions-panel.component.sass'],
    imports: [
        TranslocoModule,
        TbCheckboxComponent,
        NgTemplateOutlet,
        TbButtonComponent,
        MatMenuModule,
        TbMenuComponent,
        MatIconModule,
        ModalLayoutComponent,
        RecordActionButtonsComponent,
    ],
})
export class RecordActionsPanelComponent implements OnInit {
    dialog = inject(MatDialog)
    private readonly actionPanelService = inject(RecordActionPanelService)
    private readonly breakpointService = inject(BreakpointService)

    selectedRecords!: BaseMainBusinessRecord[]
    @ViewChild('xsmMenu') xsmMenu!: TbMenuComponent

    ngOnInit() {
        this.breakpointService.displaySize$.subscribe((size) => {
            if (size === DisplaySize.Small && this.xsmMenu?.modalManager) {
                this.xsmMenu.closeMenu()
            }
        })

        this.actionPanelService
            .getSelectedRecords$()
            .pipe(untilDestroyed(this))
            .subscribe((selectedRecords) => {
                this.selectedRecords = selectedRecords
            })
    }

    clearAllSelected() {
        this.actionPanelService.deselectAll()
    }
}
